import { _ as _baseGetTag } from "./auth-service-tools511.js";
import { i as isObjectLike_1 } from "./auth-service-tools515.js";
var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;
var argsTag = "[object Arguments]";

function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;
export { _baseIsArguments as _ };